import React from "react";

import Topbar from "../../../../components/Topbar/Topbar";
import SideBar from "../../../../components/SideBar/SideBar";

import "./SeverityWiseReport.css";
import SeverityWiseReportChild from "./SeverityWiseReportChild";
import MainContent from "../../../Home/MainContent";

const SeverityWiseReport = () => {
  return (
    <MainContent>
      <div className="parent-container">
        <SeverityWiseReportChild />
      </div>
    </MainContent>
  );
};

export default SeverityWiseReport;
